import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { ConnectionRequest } from '../../relation-request.interface';
import { userConnectionReceivedRowData } from '../connection-table-factory';

export class UserConnectionsReceivedTable {
  public buildTableData(items: ConnectionRequest[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.DATE, ColumnTypes.MANAGE];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'manage', key: 'manage' };
  }

  private getTableBody(items: ConnectionRequest[]): GridTableBody[] {
    return items.map(userConnectionReceivedRowData);
  }
}
